import { observer } from "mobx-react-lite";
import { useFormikContext } from "formik";
import { useMemo } from "react";

import { useTran } from "@/hooks";
import { MultiSelect } from "@/components/common";
import { LOCATION_OPTIONS, KEY_IMPROVEMENT } from "@/lib/constants";

const CompanySetupStepFour = observer(() => {
  const { t } = useTran();
  const { values, setFieldValue, setFieldTouched } = useFormikContext();

  const normalizeSelectValues = (nextValues) =>
    Array.isArray(nextValues)
      ? nextValues
          .map((item) => {
            if (typeof item === "string") return item.trim();
            if (item && typeof item === "object") {
              const resolved = item.value ?? item.key ?? item.id;
              if (typeof resolved === "string" || typeof resolved === "number")
                return String(resolved).trim();
            }
            return "";
          })
          .filter(Boolean)
      : [];

  const locationOptions = useMemo(() => {
    const options = [];
    const seenValues = new Set();

    LOCATION_OPTIONS.forEach((option) => {
      const value = option?.key;
      if (!value || seenValues.has(value)) return;
      seenValues.add(value);
      options.push({
        value,
        label: option.value,
      });
    });

    return options;
  }, []);
  const objectiveOptions = useMemo(
    () =>
      KEY_IMPROVEMENT.map((option) => ({
        value: option.key,
        label: option.value,
      })),
    [],
  );

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <label className="text-sm font-medium text-foreground">
          {t("In which countries do you offer your products and services?")}
        </label>
        <MultiSelect
          options={locationOptions}
          value={values.serviceCountries}
          onChange={(nextValues) => {
            setFieldValue(
              "serviceCountries",
              normalizeSelectValues(nextValues),
              true,
            );
            setFieldTouched("serviceCountries", true, false);
          }}
          placeholder={t("Select countries...")}
        />
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium text-foreground">
          {t("What are your key objectives for improvement?")}
        </label>
        <MultiSelect
          options={objectiveOptions}
          value={values.objectives}
          onChange={(nextValues) => {
            setFieldValue(
              "objectives",
              normalizeSelectValues(nextValues),
              true,
            );
            setFieldTouched("objectives", true, false);
          }}
          placeholder={t("Select objectives...")}
        />
      </div>
    </div>
  );
});

export default CompanySetupStepFour;
